export { default } from "./AdvisorCard";
